import { render, staticRenderFns } from "./BtnTableExportExcel.vue?vue&type=template&id=4ac24c16&scoped=true&"
import script from "./BtnTableExportExcel.vue?vue&type=script&lang=js&"
export * from "./BtnTableExportExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac24c16",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
